const MotionGlobalConfig = {
    skipAnimations: false,
    useManualTiming: false,
};

export { MotionGlobalConfig };
